import React from 'react';
import '../Demo.css';
import DemoSent from '../assets/images/message-sent.png';
import Logo from '../assets/images/HOCOIA-Logo-Q.png';

class DemoMailSent extends React.Component {

    constructor(props) {
        super(props);
        const searchParams = new URLSearchParams(window.location.href)
        this.state = {
            sessions: [],
            EmailPatient: ''
        }
        if (searchParams.get("email")) {
            this.state.EmailPatient = ' à l\'adresse mail : \''+searchParams.get("email")+'\'';
        }
        window.isDemoPage = true;
    }

    launchSession(){
        const searchParams = new URLSearchParams(window.location.href)
        window.page = window.open("/onetoone/"+searchParams.get("onetoone")+"/"+searchParams.get("session"),"One To One HOCOIA - " + searchParams.get("name"),"menubar=no, status=no, scrollbars=no, menubar=no, width="+window.screen.width+", height="+window.screen.height);
    }

    backToDemo(){
        window.location.href = "/demo";
    }

    render(){
        return(
            <React.Fragment>

                <div className='demo-header'>
                    <img src={Logo} alt='hocoia'/>
                </div>

                <div className="demo-mainframe">
                    <h1 className='demo-h1'>Il ne reste plus qu'à vous connecter</h1>

                    <img className='demo-img' src={DemoSent} />

                    <p className="demo-border demo-p">
                        Un lien de connexion a bien été envoyé au patient {this.state.EmailPatient}<br/>
                        <span className='demo-span'>Veuillez lui rappeler de vérifier également le dossier spam de sa boite mail</span>
                    </p>

                    <button className='demo-button' onClick={this.launchSession}>Démarrer la session</button><br/><br/>
                    <button className='demo-button demo-back' onClick={this.backToDemo}>Revenir à l'accueil</button>

                    <p className="demo-border demo-p">
                        <span className='demo-span'>L’équipe Hocoia reste à votre disposition sur <a href='mailto:support@hocoia.com'>support@hocoia.com</a> si vous rencontrez des problèmes techniques.</span>
                    </p>
                </div>

            </React.Fragment>
        )
    }
}

export default DemoMailSent;